import { createSelector } from 'reselect';

export const companiesSelector = createSelector(
    (state) => state && state.investorTracker && state.investorTracker.companies,
    (companies) => companies || [],
);

export const peopleSelector = createSelector(
    (state) => state && state.investorTracker && state.investorTracker.people,
    (people) => people || [],
);

export const locationsSelector = createSelector(
    (state) => state && state.investorTracker && state.investorTracker.locations,
    (locations) => locations || [],
);

export const currentPersonIdSelector = createSelector(
    (state) => state && state.investorTracker && state.investorTracker.currentPersonId,
    (id) => id || null,
);

export const savedContractorsSelector = createSelector(
    (state) => state && state.investorTracker && state.investorTracker.savedContractors,
    (savedContractors) => savedContractors || [],
);

export const contractorCategoriesSelector = createSelector(
    (state) => state && state.investorTracker && state.investorTracker.contractorCategories,
    (contractorCategories) => contractorCategories || [],
);
